import { sendRequest } from "../../hooks/requests/useRequest";

export async function getInformationSection() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Section/List/false`);

    if (response.code === 200) {
        const filteredData = response.data.filter(section => !section.is_micro);

        return {
            code: response.code,
            data: filteredData
        }
    } else {
        return {
            code: response.code,
            data: response?.data
        }
    }
}


export async function getInformationSectionImagen() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Section/List/true`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function GetListRuleByExam(_id_exam) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/ListRuleByExam/${_id_exam} `);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}

export async function getInformationRule() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `CatNom/List`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}


export async function saveRule(
    _id_exam, _id_method,
) {

    const body = {
        id_exam: _id_exam,
        listRule: _id_method
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Exam/CreateOrUpdateExamRule"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return response.data;

}

